import React from "react";
import { ErrorMessage } from "formik";
import clsx from "clsx";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  Box,
  ButtonBase,
  Card,
  CardContent,
  Collapse,
  Link,
  Stack,
  TextField,
  Typography,
} from "@mui/material";

function LegacyAssistantSection({
  values,
  handleChange,
  handleBlur,
  errors,
  touched,
  classes,
  hasValidationError = false,
  sectionStateKey = null,
}) {
  const [expanded, setExpanded] = React.useState(false);
  const contentId = "legacy-assistant-content";

  React.useEffect(() => {
    setExpanded(false);
  }, [sectionStateKey]);

  React.useEffect(() => {
    if (hasValidationError) {
      setExpanded(true);
    }
  }, [hasValidationError]);

  return (
    <Card variant="outlined" sx={{ backgroundColor: "#f5f5f5", borderRadius: 1 }}>
      <CardContent sx={{ pt: 2.5, pb: 0 }}>
        <ButtonBase
          aria-controls={contentId}
          aria-expanded={expanded}
          aria-label={`${expanded ? "Collapse" : "Expand"} OpenAI Assistant legacy`}
          onClick={() => setExpanded((current) => !current)}
          sx={{
            alignItems: "center",
            borderRadius: 0.5,
            display: "flex",
            justifyContent: "flex-start",
            px: 0.5,
            py: 0.5,
            width: "100%",
          }}
        >
          <Typography variant="h6" sx={{ fontWeight: 700, mb: 0 }}>
            OpenAI Assistant (legacy)
          </Typography>
          {expanded ? (
            <ExpandLessIcon aria-hidden="true" fontSize="small" sx={{ ml: 0.5 }} />
          ) : (
            <ExpandMoreIcon aria-hidden="true" fontSize="small" sx={{ ml: 0.5 }} />
          )}
        </ButtonBase>

        <Collapse in={expanded} timeout="auto" unmountOnExit>
          <Box id={contentId} sx={{ mt: 2 }}>
            <Stack>
              <TextField
                label="OpenAI Assistant Id"
                name="assistantId"
                className={clsx(
                  classes.textfield,
                  errors.assistantId && touched.assistantId
                    ? classes.inputError
                    : classes.inputNoError
                )}
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.assistantId}
                helperText={
                  values.assistantId ? (
                    <Link
                      href={`https://platform.openai.com/assistants/edit?assistant=${values.assistantId}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      View Assistant
                    </Link>
                  ) : ""
                }
              />
              <ErrorMessage
                name="assistantId"
                component="span"
                className={classes.error}
              />
            </Stack>
          </Box>
        </Collapse>
      </CardContent>
    </Card>
  );
}

export default LegacyAssistantSection;
